export default __webpack_public_path__ + "static/media/mail_black.6a0a1534.svg";